const pathObj = {
  register: '/v2/merchant/signup',
  loginUser: '/v2/merchant/login',
  verifyOtp: '/v2/merchant/verify-otp',
  resendOtp: '/v2/merchant/resend-verify-otp',

  getUsers: '/v2/merchant/users',
  createUser: '/v2/merchant/add-user',
  updateUser: '/v2/admin/user',
  changeUserStatus: '/v2/merchant/change-user-status',
  refreshToken: '/v2/user/refresh-token',
  seriesList: '/v2/user/match/series',
  matchList: '/v2/user/match/list',
  refreshAmount: '/v2/admin/refresh-amount',
  userProfile: '/v2/user/profile',
  userProfileUpdate: '/v2/user/profile-update',
  userEditStake: '/v2/user/edit-stake',
  userEditOneClickStake: '/v2/user/edit-one-click-stake',
  activityLogs: '/v2/user/activity-logs',
  transactionLogs: '/v2/user/transaction/logs',
  matchDetail: '/v2/user/match/detail',
  matchScore: '/v2/user/match/score',
  sportsList: '/v2/user/sport/list',
  inPlayCount: '/v2/user/sport/inplay-count',
  betfairPlaceBet: '/v2/user/match/betfaire-place-bet',
  soccerPlaceBet: '/v2/user/match/soccer-place-bet',
  tennisPlaceBet: '/v2/user/match/tennis-place-bet',
  userInPlaySport: '/v2/user/sport',
  bookmakerBet: '/v2/user/match/bookmaker-place-bet',
  betPosition: '/v2/user/match/get-bet-positions',
  betEventsBetPosition: '/v2/user/match/get-events-bet-positions',
  multiEventPlaceBet: '/v2/user/match/multiple-event-place-bet',
  getCurrentBetsExchanges: '/v2/user/match/my-bets',
  cancelUnmatchedBets: '/v2/user/match/clear-unmatched-bet',
  getBookmakerBets: '/v2/user/match/my-bookmaker-bets',
  getFancyBets: '/v2/user/match/my-fancy-bets',
  getSportsBook: '/v2/user/match/my-sport-book-bets',
  fancyBetPlace: '/v2/user/match/fancy-place-bet',
  multiMarket: '/v2/user/sport/multi-market',
  preminumFancyBets: '/v2/user/match/premium-fancy-place-bet',
  addMatchInMultiMarket: '/v2/user/sport/multi-market',
  getPremiumFancy: '/v2/cron/premium-fancy',
  getBetsData: '/v2/user/match/events-bets',
  getHistory: '/v2/user/match/bet-history',
  messageList: '/v2/user/message/list',
  userSubscribe: '/v2/user/subscribe',
  adminSetting: '/v2/user/site-setting/site-setting-list',
  getWalletTransactions: '/v2/admin/wallet-transaction',
  getTransactions: '/v2/merchant/transactions',
  getTransactionsExcel: '/v2/merchant/transactions/excel',
  getTransactionTypes: '/v2/configs/merchant-transaction-types',
  getTransactionDetails: '/v2/merchant/transaction-details',
  statususer: '/v2/admin/user/change-status',
  getsubadmin: '/v2/admin/subadmin/list',
  editSubadmin: '/v2/admin/subadmin/edit',
  addSubadmin: '/v2/admin/subadmin/add',
  deleteSubadmin: '/v2/admin/subadmin/delete',
  statusSub: '/v2/admin/subadmin/change-status',
  addMerchant: '/v2/admin/merchant',
  editMerchant: '/v2/admin/merchant',
  getMerchantList: '/v2/admin/merchant/list',
  deleteMerchant: '/v2/admin/merchant',
  changeMerchantStatus: '/v2/admin/merchant/status',
  updateSettings: '/v2/admin/setting',
  updateMcrSettings: '/v2/admin/mcr-settings',
  getSettings: '/v2/admin/setting',
  getMcrSettings: '/v2/admin/mcr-settings',
  changeMerchantVerified: '/v2/admin/merchant/verify',
  getContactUs: '/v2/admin/contact-us',
  changeFAQStatus: '/v2/admin/faqs/status',
  getStaticContent: '/v2/admin/static-content',
  forgotPassword: '/v2/merchant/forgot-password',
  resetPassword: '/v2/merchant/reset-password',
  changePassword: '/v2/merchant/change-password',
  editProfile: '/v2/merchant/edit-profile',
  getCategoryList: '/v2/merchant/list',
  getAllOffers: '/v2/admin/offers',
  getAllStaffs: '/v2/merchant/agents-list',
  addStaffs: '/v2/merchant/add-agent',
  editStaffs: '/v2/merchant/edit-agent',
  changeStatus: '/v2/merchant/change-status',
  deleteStaff: '/v2/merchant/delete-agent',
  notificationToggle: '/v2/merchant/notification-toggle',
  getUserDetails: '/v2/admin/user/details',
  getDashboardDetails: '/v2/merchant/dashboard',
  getCompleteProfile: '/v2/merchant',
  getTransaction: '/v2/merchant/transactions',
  updateCompleteProfile: '/v2/merchant/complete-profile',
  getAllMerchantOffers: '/v2/merchant/list-offer',
  merchantOfferChangeStatus: '/v2/merchant/offer-status-update',
  deleteMerchantOffer: '/v2/merchant/delete-offer',
  editMerchantOffer: '/v2/merchant/edit-offer',
  addMerchantOffer: '/v2/merchant/add-offer',
  merchantNotifications: '/v2/merchant/notifications',
  merchantInvoices: '/v2/merchant/wallet/invoice',
  merchantCreateInvoice: '/v2/merchant/wallet/create-invoice',
  agentPaymentList: '/v2/merchant/wallet/agent-wallet-list',
  paymentSettlementRequest: '/v2/merchant/wallet/transfer-request',
  transferMoneyMerchant: '/v2/merchant/wallet/accept-transfer-request',
  AddCashIn: '/v2/merchant/wallet/cash-in',
  AddBalance: '/v2/merchant/wallet/add-operator-balance',
  cashInPreview: '/v2/merchant/wallet/cash-in-preview',
  TransferCash: '/v2/merchant/wallet/cash-transfer',
  cashTransferPreview: '/v2/merchant/wallet/cash-transfer-preview',
  cashTransferSendOtp: '/v2/merchant/wallet/cash-transfer-send-otp',
  AddCashOut: '/v2/merchant/wallet/cash-out',
  cashOutPreview: '/v2/merchant/wallet/cash-out-preview',
  cashOutSendOtp: '/v2/merchant/wallet/cash-out-send-otp',
  getAllWallet: '/v2/merchant/wallet/statement',
  refundList: '/v2/merchant/wallet/refunds',
  initiateRefund: '/v2/merchant/wallet/refund',
  merchantSplitBillPaymentList: '/v2/merchant/split-bill-payment/group-list',
  merchantSplitBillPaymentDetail:
    '/v2/merchant/split-bill-payment/group-detail',
  merchantSplitBillPaymentCheckMobile:
    '/v2/merchant/split-bill-payment/check-mobile',
  merchantSplitBillPaymentSendRequest:
    '/v2/merchant/split-bill-payment/send-request',
  sampleSalary: '/v2/merchant/wallet/salary-sample',
  salaryPayment: '/v2/merchant/wallet/salary-payment',
  transactions: '/v2/merchant/transactions',
  getReports: '/v2/merchant/reports/types',
  downloadReports: '/v2/merchant/reports',
  orders: '/v2/merchant/orders',
  merchantQR: '/v2/merchant/merchant-qr-code',
  staticContent: 'v1/user/static-content/list',
  staticContentSlug: 'v1/user/static-content?slug',
  getFaqs: '/v2/user/static-content/faqs',
  forgotPasswordOtp: '/v2/user/forgot-password',
  bankList: '/v2/merchant/wallet/bank-accounts',
  bankCommission: '/v2/user/wallet/transfer-commissions',
  transferToBank: '/v2/merchant/wallet/transfer-to-bank',
  downloadTransactions: '/v2/merchant/download-transactions',
  verifyLoginOtp: '/v2/merchant/login-verify-otp',
  getUserWallets: '/v2/merchant/wallet/user-wallets',
}

export default pathObj
